export const headerStyles = { boxShadow: 3 };

export const headerLeftStyles = { flexGrow: 1 };

export const appbarStyles = { backgroundColor: "#fff", my: "0px", mx: "0px", py: "0px" };

export const avatarStyles = { width: "10vh", height: "8vh", backgroundColor: '#fff' };

export const searchIconStyle = { width: "36px", height: "40px", color: '#aaa' };
